var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    ref: "adhese",
    staticClass: "adhese",
    class: { "extend-container": _vm.extendContainer },
    attrs: {
      "data-adhese-domain": _vm.adhesePosition,
      "data-adhese-format": _vm.adheseFormat,
      "data-adhese-position": _vm.language,
      "data-adhese-pagetype": _vm.adhesePagetype,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }